import React, { useState, useEffect, useCallback } from "react";
import List from "../articleList";
import Filter from "../articleFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import { useNavigate } from "react-router-dom";
import * as VarietyService from "../../../../services/VarietyService";
import * as GeneralServices from "../../../../services/GeneralServices";
import { SET_FILTER_ARTICLE } from "../../../../constants";
import { getFilterArticleSelector } from "../../../../store/selectors/navSelector";
import { useSelector } from "react-redux";

const queryClient = new QueryClient();

const ArticleFilterListContainer = (props) => {
  const { t } = useTranslation();
  // const [filters, setFilters] = useState(undefined);
  const [varieties, setVarieties] = useState([]);
  const navigate = useNavigate();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.article.title") },
  ];
  const filters = useSelector(getFilterArticleSelector);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    // setFilters(undefined);
    GeneralServices.setFilter(undefined, SET_FILTER_ARTICLE);
  };

  const loadData = useCallback(async () => {
    const resultItems = await VarietyService.getAllVarieties();
    if (resultItems && resultItems.length > 0) {
      const dataVarieties = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setVarieties(dataVarieties);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  const goToForm = async () => {
    navigate(PATHS.CREATE_ARTICLE);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    // setFilters(newFilter);
    GeneralServices.setFilter(newFilter, SET_FILTER_ARTICLE);
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.article.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            varieties={varieties}
            initialValues={filters}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
      <div className="row justify-content-center mt-4 mb-5">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <button
            className="btn btn-secondary btn-md"
            onClick={() => goToForm()}
          >
            {t("forms.article.buttons.new")}
          </button>
        </div>
      </div>
    </>
  );
};

ArticleFilterListContainer.propTypes = {};

export default ArticleFilterListContainer;
